var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseListItem',{staticClass:"listItemLocation",attrs:{"text":_vm.text,"title":_vm.title,"showIcon":false},on:{"click":function($event){return _vm.$emit('click')}},scopedSlots:_vm._u([{key:"logo",fn:function(){return [_c('locationIcon',{staticClass:"listItemLocation__logo"})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }